<template>
  <div class="content-dashboard">
    <div class="d-flex align-items-center justify-content-between">
      <h3>{{ $t("addresses.title") }}</h3>
      <div class="right-adress-item">
        <button class="btn btn-orange" data-bs-toggle="modal" data-bs-target="#addressModal" @click="openAddModal">
          <img :src="plus" class="w-10" /> {{ $t("addresses.add_button") }}
        </button>
      </div>
    </div>

    <div v-if="addressesStore.loading" class="text-center mt-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">{{ $t("addresses.loading") }}</span>
      </div>
    </div>

    <div v-else-if="addressesStore.error" class="alert alert-danger mt-3">
      {{ addressesStore.error }}
      <button @click="loadAddresses" class="btn btn-sm btn-outline-danger ms-2">
        {{ $t("addresses.retry") }}
      </button>
    </div>

    <div v-else-if="!addressesStore.hasAddresses" class="text-center mt-5">
      <p class="text-muted">{{ $t("addresses.no_addresses") }}</p>
      <button class="btn btn-orange" data-bs-toggle="modal" data-bs-target="#addressModal" @click="openAddModal">
        {{ $t("addresses.add_first_address") }}
      </button>
    </div>

    <div v-else class="row mb-5 mt-5">
      <div class="col-lg-12">
        <div v-for="(address, index) in addressesStore.sortedAddresses" :key="address.id" class="chart-box mb-4">
          <div class="gray-box">
            <div class="adress-item bg-transparent d-flex justify-content-between w-100 align-items-center p-0">
              <p class="mb-0">
                <i class="ti ti-location-pin blue-color"></i>
                <strong class="blue-color font-bold"> {{ $t("addresses.address_label") }} {{ index + 1 }}</strong> :
                {{ formatClientAddress(address) }}
              </p>

              <div class="d-flex gap-2">
                <button
                  @click="openEditModal(address)"
                  class="btn btn-orange btn-circle"
                  :title="$t('addresses.edit_tooltip')"
                  data-bs-toggle="modal"
                  data-bs-target="#addressModal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18.5" height="18.5" viewBox="0 0 18.5 18.5">
                    <g id="edit" transform="translate(-3.25 -2.25)">
                      <path
                        id="Tracé_13934"
                        data-name="Tracé 13934"
                        d="M16.475,5.408l2.117,2.117m-.756-3.982L12.109,9.27a2.118,2.118,0,0,0-.579,1.082L11,13l2.648-.53a2.118,2.118,0,0,0,1.082-.579l5.727-5.727a1.854,1.854,0,0,0-2.621-2.621Z"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_13935"
                        data-name="Tracé 13935"
                        d="M19,15v3a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V7A2,2,0,0,1,6,5H9"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                    </g>
                  </svg>
                </button>
                <button
                  v-if="address.adrcod !== divaltoId"
                  @click="confirmDelete(address)"
                  class="btn btn-orange btn-circle"
                  :title="$t('addresses.delete_tooltip')"
                  data-bs-toggle="modal"
                  data-bs-target="#deleteConfirmModal"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="17.5" height="19.5" viewBox="0 0 17.5 19.5">
                    <g id="delete-svgrepo-com_2_" data-name="delete-svgrepo-com (2)" transform="translate(0.75 0.75)">
                      <path
                        id="Tracé_5768"
                        data-name="Tracé 5768"
                        d="M10,11v6"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5769"
                        data-name="Tracé 5769"
                        d="M14,11v6"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5770"
                        data-name="Tracé 5770"
                        d="M4,7H20"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5771"
                        data-name="Tracé 5771"
                        d="M6,7H18V18a3,3,0,0,1-3,3H9a3,3,0,0,1-3-3Z"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                      <path
                        id="Tracé_5772"
                        data-name="Tracé 5772"
                        d="M9,5a2,2,0,0,1,2-2h2a2,2,0,0,1,2,2V7H9Z"
                        transform="translate(-4 -3)"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1.5"
                      ></path>
                    </g>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="addressModal"
    ref="addressModal"
    tabindex="-1"
    aria-labelledby="modalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-width">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button
            type="button"
            class="close-link"
            data-bs-dismiss="modal"
            :aria-label="$t('addresses.modal.close_button_label')"
          >
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal">
          <div v-if="!saveSuccess">
            <h3>{{ isEditMode ? $t("addresses.modal.edit_title") : $t("addresses.modal.add_title") }}</h3>
            <form @submit.prevent="handleSubmit" class="mt-4">
              <div class="d-flex gap-3">
                <div class="input-form" style="flex: 1">
                  <label class="label-control">Société</label>
                  <input type="text" class="form-control" v-model="form.company" />
                </div>
              </div>
              <div class="d-flex gap-3">
                <div class="input-form">
                  <label class="label-control">{{ $t("addresses.modal.labels.address") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.address"
                    :class="{ 'is-invalid': errors.address }"
                    required
                  />
                  <div v-if="errors.address" class="invalid-feedback">
                    {{ errors.address }}
                  </div>
                </div>
                <div class="input-form">
                  <label class="label-control">{{ $t("addresses.modal.labels.postal_code") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.postalCode"
                    v-only-digits
                    :class="{ 'is-invalid': errors.postalCode }"
                    required
                  />
                  <div v-if="errors.postalCode" class="invalid-feedback">
                    {{ errors.postalCode }}
                  </div>
                </div>
              </div>

              <div class="d-flex gap-3">
                <div class="input-form">
                  <label class="label-control">{{ $t("addresses.modal.labels.city") }}</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.city"
                    :class="{ 'is-invalid': errors.city }"
                    required
                  />
                  <div v-if="errors.city" class="invalid-feedback">
                    {{ errors.city }}
                  </div>
                </div>
                <div class="input-form">
                  <label class="label-control">{{ $t("addresses.modal.labels.country") }}</label>
                  <select
                    class="form-control"
                    v-model="form.country"
                    :class="{ 'is-invalid': errors.country }"
                    required
                  >
                    <option v-for="country in countries" :key="country.code" :value="country.code">
                      {{ country.name }}
                    </option>
                  </select>
                  <div v-if="errors.country" class="invalid-feedback">
                    {{ errors.country }}
                  </div>
                </div>
              </div>

              <div class="d-flex gap-3">
                <div class="input-form">
                  <label class="label-control">{{ $t("addresses.modal.labels.email") }}</label>
                  <input
                    type="email"
                    class="form-control"
                    v-model="form.email"
                    :class="{ 'is-invalid': errors.email }"
                    :placeholder="$t('addresses.modal.placeholders.email')"
                    required
                  />
                  <div v-if="errors.email" class="invalid-feedback">
                    {{ errors.email }}
                  </div>
                </div>
                <div class="input-form">
                  <label class="label-control">{{ $t("addresses.modal.labels.phoneNumber") }}</label>
                  <input
                    type="tel"
                    class="form-control"
                    v-model="form.cellphone"
                    v-only-digits
                    :class="{ 'is-invalid': errors.cellphone }"
                    :placeholder="$t('addresses.modal.placeholders.phoneNumber')"
                    required
                  />
                  <div v-if="errors.cellphone" class="invalid-feedback">
                    {{ errors.cellphone }}
                  </div>
                </div>
              </div>

              <div class="input-form w-100">
                <label class="label-control">{{ $t("addresses.modal.labels.message") }}</label>
                <textarea
                  class="form-control round-15"
                  rows="4"
                  v-model="form.message"
                  :placeholder="$t('addresses.modal.placeholders.message')"
                ></textarea>
              </div>

              <div v-if="error" class="alert alert-danger mt-3">
                {{ error }}
              </div>

              <div class="d-flex justify-content-center">
                <button type="submit" class="btn btn-orange" :disabled="loading">
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"></span>
                  {{
                    loading
                      ? isEditMode
                        ? $t("addresses.modal.buttons.updating")
                        : $t("addresses.modal.buttons.saving")
                      : isEditMode
                        ? $t("addresses.modal.buttons.update")
                        : $t("addresses.modal.buttons.save")
                  }}
                </button>
              </div>
            </form>
          </div>

          <div v-else class="text-center">
            <div class="mb-4">
              <i class="ti ti-check-circle" style="font-size: 4rem; color: #28a745"></i>
            </div>
            <h3 class="mb-3">{{ isEditMode ? $t("addresses.success.updated") : $t("addresses.success.created") }}</h3>

            <div class="d-flex justify-content-center">
              <button type="button" class="btn btn-orange" data-bs-dismiss="modal">
                {{ $t("addresses.modal.buttons.close") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="deleteConfirmModal"
    ref="deleteConfirmModal"
    tabindex="-1"
    aria-labelledby="deleteModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-width">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button
            type="button"
            class="close-link"
            data-bs-dismiss="modal"
            :aria-label="$t('addresses.modal.close_button_label')"
          >
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal">
          <div v-if="!deleteSuccess">
            <h3>{{ $t("addresses.delete_modal.title") }}</h3>
            <div class="mt-4 mb-4">
              <p class="mb-3">{{ $t("addresses.delete_modal.message") }}</p>
              <div v-if="addressToDelete" class="gray-box">
                <div class="adress-item bg-transparent d-flex justify-content-start w-100 align-items-center p-3">
                  <p class="mb-0">
                    <i class="ti ti-location-pin blue-color me-2"></i>
                    <strong class="blue-color font-bold">{{ $t("addresses.delete_modal.address_to_delete") }} :</strong>
                    {{ formatClientAddress(addressToDelete) }}
                  </p>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center gap-3">
              <button type="button" class="btn btn-outline-orange" data-bs-dismiss="modal">
                {{ $t("addresses.delete_modal.cancel") }}
              </button>
              <button type="button" class="btn btn-orange" @click="deleteAddress" :disabled="deletingAddress">
                <span v-if="deletingAddress" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ deletingAddress ? $t("addresses.delete_modal.deleting") : $t("addresses.delete_modal.confirm") }}
              </button>
            </div>
          </div>
          <div v-else class="text-center">
            <div class="mb-4">
              <i class="ti ti-check-circle" style="font-size: 4rem; color: #28a745"></i>
            </div>
            <h3 class="mb-3">{{ $t("addresses.success.deleted") }}</h3>
            <p class="text-muted mb-4">{{ $t("addresses.success.deleted") }}</p>
            <div class="d-flex justify-content-center">
              <button type="button" class="btn btn-orange" data-bs-dismiss="modal">
                {{ $t("addresses.modal.buttons.close") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import plus from "@/assets/images/plus-circle.svg";
  import { useAddressesStore } from "@/stores/esupplyvet/addressesStore";
  import { useRegisterStore } from "@/stores/register";
  import { getCountries } from "@/api/auth";

  export default {
    name: "AdresseLivraisonViewClient",

    data() {
      return {
        plus,
        countries: [],
        currentAddress: null,
        addressToDelete: null,
        deletingAddress: false,
        deleteSuccess: false,
        saveSuccess: false,
        loading: false,
        error: null,
        form: {
          company: "",
          address: "",
          postalCode: "",
          city: "",
          country: "FR",
          email: "",
          cellphone: "",
          message: "",
        },
        errors: {},
      };
    },

    computed: {
      addressesStore() {
        return useAddressesStore();
      },

      isEditMode() {
        return !!this.currentAddress;
      },

      registerStore() {
        return useRegisterStore();
      },

      divaltoId() {
        return this.registerStore.VeterinaireData?.divalto_id || null;
      },
    },

    async mounted() {
      await this.loadAddresses();
      await this.getCountries();
      await this.registerStore.fetchVeterinaire();
      this.setupModalEventListeners();
    },

    beforeUnmount() {
      this.removeModalEventListeners();
    },

    methods: {
      async getCountries() {
        try {
          const response = await getCountries();
          this.countries = response.data;
        } catch (error) {
          console.error("Erreur chargement pays:", error);
        }
      },
      async loadAddresses() {
        try {
          await this.addressesStore.fetchAddresses();
        } catch (error) {
          console.error("Erreur chargement adresses:", error);
        }
      },

      formatAddress(address) {
        if (!address) return "";

        const parts = [];
        if (address.address) parts.push(address.address);
        if (address.postalCode) parts.push(address.postalCode);
        if (address.city) parts.push(address.city);
        if (address.country && address.country !== "France") parts.push(address.country);

        return parts.join(" - ");
      },

      formatClientAddress(address) {
        if (!address) return "";

        const locationParts = [];
        if (address.company) locationParts.push(address.company);
        if (address.street) locationParts.push(address.street);
        if (address.postcode && address.city) {
          locationParts.push(`${address.postcode} ${address.city}`);
        } else {
          if (address.postcode) locationParts.push(address.postcode);
          if (address.city) locationParts.push(address.city);
        }
        // Add country name
        const countryName = this.getCountryName(address.countryCode);
        if (countryName) locationParts.push(countryName);

        let result = locationParts.join(", ");

        // Add email and cellphone if they exist
        if (address.email || address.cellphone) {
          const contactParts = [];
          if (address.email) contactParts.push(`Email: ${address.email}`);
          if (address.cellphone) contactParts.push(`Tel: ${address.cellphone}`);
          result += ` (${contactParts.join(", ")})`;
        }

        // Add message if it exists
        if (address.message && address.message.trim()) {
          result += ` (${address.message})`;
        }

        return result || this.$t("addresses.undefined_address");
      },

      openAddModal() {
        this.currentAddress = null;
        this.saveSuccess = false;
        this.resetForm();
      },

      openEditModal(address) {
        this.currentAddress = address;
        this.saveSuccess = false;
        this.form = {
          company: address.company || "",
          address: address.street || "",
          postalCode: address.postcode || "",
          city: address.city || "",
          country: address.countryCode || "FR",
          email: address.email || "",
          cellphone: address.cellphone || "",
          message: address.message || "",
        };
        this.errors = {};
        this.error = null;
      },

      confirmDelete(address) {
        this.addressToDelete = address;
        this.deleteSuccess = false;
      },

      async deleteAddress() {
        if (!this.addressToDelete) return;

        this.deletingAddress = true;

        try {
          await this.addressesStore.deleteAddress(this.addressToDelete.id);
          this.deleteSuccess = true;
          this.addressToDelete = null;
        } catch (error) {
          if (this.$toast) {
            this.$toast.error(this.$t("addresses.errors.delete_failed"));
          }
          console.error("Erreur suppression adresse:", error);
        } finally {
          this.deletingAddress = false;
        }
      },

      resetDeleteModal() {
        this.deleteSuccess = false;
        this.addressToDelete = null;
        this.deletingAddress = false;
      },

      resetSaveModal() {
        this.saveSuccess = false;
        this.resetForm();
      },

      setupModalEventListeners() {
        if (this.$refs.addressModal) {
          this.$refs.addressModal.addEventListener("hidden.bs.modal", this.onAddressModalHidden);
        }
        if (this.$refs.deleteConfirmModal) {
          this.$refs.deleteConfirmModal.addEventListener("hidden.bs.modal", this.onDeleteModalHidden);
        }
      },

      removeModalEventListeners() {
        if (this.$refs.addressModal) {
          this.$refs.addressModal.removeEventListener("hidden.bs.modal", this.onAddressModalHidden);
        }
        if (this.$refs.deleteConfirmModal) {
          this.$refs.deleteConfirmModal.removeEventListener("hidden.bs.modal", this.onDeleteModalHidden);
        }
      },

      onAddressModalHidden() {
        this.saveSuccess = false;
        this.resetForm();
      },

      onDeleteModalHidden() {
        this.deleteSuccess = false;
        this.addressToDelete = null;
        this.deletingAddress = false;
      },

      async handleSubmit() {
        if (!this.validateForm()) {
          return;
        }

        this.loading = true;
        this.error = null;

        try {
          if (this.isEditMode) {
            await this.addressesStore.updateAddress(this.currentAddress.id, this.form);
          } else {
            console.log("Creating address with data:", this.form);
            await this.addressesStore.createAddress(this.form);
          }
          this.saveSuccess = true;
        } catch (error) {
          this.error = this.isEditMode
            ? this.$t("addresses.errors.update_failed")
            : this.$t("addresses.errors.create_failed");
          console.error("Erreur sauvegarde adresse:", error);
        } finally {
          this.loading = false;
        }
      },

      validateForm() {
        this.errors = {};

        if (!this.form.address.trim()) {
          this.errors.address = this.$t("addresses.errors.address_required");
        }

        if (!this.form.postalCode.trim()) {
          this.errors.postalCode = this.$t("addresses.errors.postal_code_required");
        }

        if (!this.form.city.trim()) {
          this.errors.city = this.$t("addresses.errors.city_required");
        }

        if (!this.form.country.trim()) {
          this.errors.country = this.$t("addresses.errors.country_required");
        }

        if (!this.form.email.trim()) {
          this.errors.email = this.$t("addresses.errors.email_required");
        } else if (!this.isValidEmail(this.form.email)) {
          this.errors.email = this.$t("addresses.errors.email_invalid");
        }

        if (!this.form.cellphone.trim()) {
          this.errors.cellphone = this.$t("addresses.errors.telephone_required");
        } else if (!this.isValidTelephone(this.form.cellphone)) {
          this.errors.cellphone = this.$t("addresses.errors.telephone_invalid");
        }

        return Object.keys(this.errors).length === 0;
      },

      isValidEmail(email) {
        // Basic email validation regex
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      },

      isValidTelephone(cellphone) {
        // Basic cellphone validation (allows numbers, spaces, dashes, and optional country code)
        const phoneRegex = /^\+?\d[\d\s-]{8,}$/;
        return phoneRegex.test(cellphone);
      },

      resetForm() {
        this.form = {
          company: "",
          address: "",
          postalCode: "",
          city: "",
          country: "FR",
          email: "",
          cellphone: "",
          message: "",
        };
        this.errors = {};
        this.error = null;
        this.currentAddress = null;
      },

      getCountryName(countryCode) {
        const country = this.countries.find(c => c.code === countryCode);
        return country ? country.name : countryCode;
      },
    },
  };
</script>
